import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import basketEn from 'translations/en/basket.json';
import basketTh from 'translations/th/basket.json';

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: 'en',
  lng: 'en',
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      translation: basketEn
    },
    th: {
      translation: basketTh
    }
  }
});

export default i18n;
